import Application from "../features/contests/components/application/Application";

const InvolvementPage = () => <Application />;

export default InvolvementPage;
